import { render, staticRenderFns } from "./JugeByLeader.vue?vue&type=template&id=06ab1cfe&"
import script from "./JugeByLeader.vue?vue&type=script&lang=js&"
export * from "./JugeByLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports